import React from "react";

export default function MSAccess_Day() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Day</h1>
      <p>This is the MSAccess_Day component generated from the SQL JSON.</p>
    </div>
  );
}
